import { Inject, Injectable, Optional } from '@angular/core';

import { NgxMatDateFormats } from '@angular-material-components/datetime-picker';

import { NgxMatMomentAdapter } from '@angular-material-components/moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { AppConst } from './app-const';


@Injectable()
export class AppDateAdapter extends NgxMatMomentAdapter {

  constructor( @Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string ) {
      super(dateLocale);
  }

  override format(date: any, displayFormat: any): string {
    return date.format(AppConst.FORMAT_DATE_YYYYMMDD_PYPHEN);
  }

  override getDateNames(): string[] {
     const dateNames: string[] = [];
     for (let i = 0; i < 31; i++) {
       dateNames[i] = String(i + 1);
     }
     return dateNames;
  }

  override getMonthNames(): string[] {
     const monthNames: string[] = [];
     for (let i = 0; i < 12; i++) {
       monthNames[i] = String(i + 1);
     }
     return monthNames;
  }

  override getYearName(date: any): string {
      return date.format('YYYY');
  }

}
export const APP_DATE_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'numeric' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric'
    },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  }
};
